import gql from "graphql-tag";

export const verifyActionCode = gql`
  mutation VerifyActionCode($email: String!, $code: String!) {
    VerifyActionCode(input: { email: $email, code: $code, action: "register" }) {
      success
    }
  }
`;
